import { render } from "./TimetableTable.vue?vue&type=template&id=61cf8779&scoped=true&lang=pug"
import script from "./TimetableTable.vue?vue&type=script&lang=ts"
export * from "./TimetableTable.vue?vue&type=script&lang=ts"

import "./TimetableTable.vue?vue&type=style&index=0&id=61cf8779&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61cf8779"

export default script